const TabletEdit = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.938 27H5C4.448 27 4 26.552 4 26V4C4 3.448 4.448 3 5 3H21C21.552 3 22 3.448 22 4V20.172L24 18.172V2C24 0.346 22.654 -1 21 -1H5C3.346 -1 2 0.346 2 2V28C2 29.654 3.346 31 5 31H14.939L15.938 27Z"
        fill={color}
      />
      <path
        d="M26.379 18.621L18 27L17 31L21 30L29.379 21.621C30.203 20.797 30.21 19.452 29.379 18.621C28.55 17.793 27.207 17.793 26.379 18.621Z"
        fill={color}
      />
    </svg>
  );
};
export default TabletEdit;
